import React from 'react';
import { motion } from 'framer-motion';

interface PostUploadProgressProps {
  progress: number;
  state: string;
}

const PostUploadProgress: React.FC<PostUploadProgressProps> = ({ progress, state }) => {
  const getStatusText = () => {
    switch (state) {
      case 'uploading':
        return `Uploading... ${Math.round(progress)}%`;
      case 'moderating':
        return 'Processing...';
      case 'success':
        return 'Finalizing...';
      default:
        return '';
    }
  };

  return (
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center p-4 z-10">
      <div className="w-full max-w-xs text-center">
        <p className="text-white text-sm font-medium mb-2">{getStatusText()}</p>
        <div className="w-full bg-gray-700 rounded-full h-2 overflow-hidden">
          <motion.div
            className="bg-white h-2 rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PostUploadProgress;
